/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Field_Open_HintInputs */

const en_us2_clubs_field_open_hint = /** @type {(inputs: Clubs_Field_Open_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applies to clubs listed among open clubs.`)
};

const pt_br2_clubs_field_open_hint = /** @type {(inputs: Clubs_Field_Open_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vale para clubes que aparecem na lista de clubes abertos.`)
};

const es_419_clubs_field_open_hint = /** @type {(inputs: Clubs_Field_Open_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se aplica a los clubes que aparecen entre los clubes abiertos.`)
};

const pt_pt2_clubs_field_open_hint = /** @type {(inputs: Clubs_Field_Open_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplica-se a clubes que aparecem na lista de clubes abertos.`)
};

const fr_fr2_clubs_field_open_hint = /** @type {(inputs: Clubs_Field_Open_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'applique aux clubs listés parmi les clubs ouverts.`)
};

const de_de2_clubs_field_open_hint = /** @type {(inputs: Clubs_Field_Open_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gilt für Clubs, die unter den offenen Clubs stehen.`)
};

const it_it2_clubs_field_open_hint = /** @type {(inputs: Clubs_Field_Open_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vale per i club elencati tra i club aperti.`)
};

/**
* | output |
* | --- |
* | "Applies to clubs listed among open clubs." |
*
* @param {Clubs_Field_Open_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_field_open_hint = /** @type {((inputs?: Clubs_Field_Open_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Field_Open_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_field_open_hint(inputs)
	if (locale === "es-419") return es_419_clubs_field_open_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_field_open_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_field_open_hint(inputs)
	if (locale === "de-DE") return de_de2_clubs_field_open_hint(inputs)
	if (locale === "it-IT") return it_it2_clubs_field_open_hint(inputs)
	return en_us2_clubs_field_open_hint(inputs)
});
export { clubs_field_open_hint as "clubs.field_open_hint" }